import { Link } from "react-router-dom";

const COLS = [
  { title: "Platform", links: [["Opportunities", "/opportunities"], ["Industries", "/industries"], ["Events", "/events"], ["10XEXIM", "/members"], ["Membership", "/membership"]] },
  { title: "Intelligence", links: [["Intelligence Hub", "/intelligence"], ["Capital Advisory", "/capital-advisory"], ["Post Requirement", "/rfq"]] },
  { title: "Company", links: [["Membership", "/membership"], ["About", "/about"], ["Contact", "/contact"], ["Privacy / Opt-out", "/opt-out"]] },
  { title: "Partners", links: [["Partner With Us", "/partner/register"], ["Partner Login", "/partner/login"], ["Event Organisers", "/events/organiser/login"], ["Add Your Event", "/events/organiser/register"]] },
];

export function Footer() {
  return (
    <footer className="border-t border-slate-800 bg-navy-950" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="logo-trail-wrap rounded-sm bg-white px-1.5 py-0.5">
              <img src="https://customer-assets-eiarnc6j.emergentagent.net/job_b2b-intelligence-2/artifacts/08rr2gpw_file_0000000021d08208bdb939d8b8dd4a57.png" alt="10XGLOBAL" className="h-11 w-auto block" />
              <span className="logo-trail-glow" aria-hidden="true" />
              <span className="logo-trail-spark" aria-hidden="true" />
            </span>
          </div>
          <p className="text-xs font-mono uppercase tracking-widest text-gold mb-3">The B2B Intelligence & Growth Network</p>
          <p className="text-sm text-slate-500 leading-relaxed max-w-xs">Verified businesses. Intelligent matching. Real opportunities. Discover. Connect. Convert. Grow 10X.</p>
          <p className="text-xs text-slate-500 mt-4">Founder & CEO: <span className="text-slate-300">Rathod Anand Singh</span></p>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <p className="text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-4">{c.title}</p>
            <ul className="space-y-2.5">
              {c.links.map(([label, href]) => (
                <li key={href}><Link to={href} className="text-sm text-slate-400 hover:text-gold transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs text-slate-600 font-mono">
        <p>© 2026 10XGLOBAL · 10x-global.com · Verification confirms identity attributes only — not financial performance, legality or creditworthiness.</p>
      </div>
    </footer>
  );
}
